export const validPaths = [
  '/',
  '/redefinicaoSenha',
  '/patio/cadastros/veiculos',
  '/patio/cadastros/motoristas',
  '/patio/cadastros/transportadoras',
  '/patio/cadastros/proprietarios_carga',
  '/patio/cadastros/motoristas/adicionar',
  '/patio/cadastros/mensalistas',
  '/patio/cadastros/terminais',
  '/patio/comercial/custo_triagem',
  '/patio/comercial/custo_estadia',
  '/patio/comercial/bumerangue',
  '/patio/financeiro/caixa_geral',
  '/patio/financeiro/faturamento',
  '/patio/financeiro/movimentacoes',
  '/patio/operacoes_patio/servicos',
  '/patio/operacoes_patio/faturamento',
  '/patio/operacoes_patio/guiches',
  '/patio/operacoes_patio/painel_chamadas',
  '/patio/operacoes_patio/guiches/movimentacoes',
  '/patio/operacoes_patio/cancelas',
  '/patio/operacoes_patio/cancela_manual',
  '/patio/operacoes_patio/cancela_manual_spe',
  '/patio/configuracoes/tipos_servicos',
  '/patio/configuracoes/tipos_carga_spe',
  '/patio/operacoes_patio/entrada_saida_veiculos',
  '/patio/operacoes_patio/entrada_saida_veiculos_spe',
  '/patio/operacoes_patio/triagens',
  '/patio/operacoes_porto/agendada',
  '/patio/operacoes_porto/agendada_spe',
  '/patio/operacoes_patio/spe',
  '/patio/operacoes_porto/carrossel',
  '/patio/auditoria/entrada_veiculos',
  '/patio/configuracoes/validacao_crlv',
  '/patio/configuracoes/parametros',
  '/patio/configuracoes/usuarios',
  '/patio/configuracoes/grupos',
  '/patio/indicadores/powerbi',
  '/transportadora/cadastros/veiculos',
  '/transportadora/operacoes_porto/agendada',
  '/transportadora/operacoes_porto/carrossel',
  '/transportadora/operacoes_patio/triagens',
];
